export const LETRAS = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ'];
export const CLAVES_COLUMNAS = [
  'fullName',
  'ownKey',
  'age',
  'email',
  'bossKey',
  'country',
  'location',
  'area',
  'charge',
  'homologado',
  'antiquity',
  'workCondition',
  'typeofwork',
  'gender',
  'academico',
  'contratacion',
  'personal',
  'jornada',
  'rotacion',
  'phone',
  'extension',
  'cellphone',
  'native',
  'answer',
  'geo_1',
  'geo_2',
  'geo_3',
  'geo_4',
  'geo_5',
  'structure_1',
  'structure_2',
  'structure_3',
  'structure_4',
  'structure_5',
  'structure_6',
  'structure_7',
  'structure_8',
  'structure_9',
  'structure_10',
  'id_CT'
];
export const TIPO_VALIDACION = [
  'alfabetica',
  'clavenumerica',
  'numerica',
  'email',
  'alfanumerica',
  'alfabetica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'date',
  'alfanumerica',
  'alfabetica',
  'alfabetica',
  'alfabetica',
  'alfabetica',
  'alfabetica',
  'alfanumerica',
  'alfanumerica',
  'numerica',
  'numerica',
  'numerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'alfanumerica',
  'numerica'
];
export const COLUMNAS_OBLIGATORIAS = [
  'fullName',
  'ownKey',
  'email',
  'phone',
  'extension',
  'cellphone',
  'country',
  'location',
  'area',
  'bossKey',
  'native',
  'charge',
  'answer',
  'age',
  'gender',
  'typeofwork',
  'workCondition',
  'antiquity',
  'id_CT'
];
export const COLUMNAS_NO_REPETIR = [
  'ownKey',
  'email'

];
export const FORMATO_ADMITIDO = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12'
];

export const CLAVES_COLUMNACT = [
  'fullName',
  'ownKey',
  'age',
  'email',
  'bossKey',
  'country',
  'location',
  'area',
  'charge',
  'homologado',
  'antiquity',
  'workCondition',
  'typeofwork',
  'gender',
  'academico',
  'contratacion',
  'personal',
  'jornada',
  'rotacion',
  'phone',
  'extension',
  'cellphone',
  'native',
  'answer',
  'geo_1',
  'geo_2',
  'geo_3',
  'geo_4',
  'geo_5',
  'structure_1',
  'structure_2',
  'structure_3',
  'structure_4',
  'structure_5',
  'structure_6',
  'structure_7',
  'structure_8',
  'structure_9',
  'structure_10',
  'id_CT'
];
export interface Colaborador {
  _id?: string,
  productoId: string,
  fullName?: string,
  ownKey: number,
  email: string,
  phone: number,
  extension: number,
  cellphone: number,
  country: string,
  location: string,
  area: string,
  bossKey: number,
  native: string,
  charge: string,
  answer: string,
  age: number,
  gender: string,
  typeofwork: string,
  workCondition: string,
  antiquity: string,
  geo_1?: string,
  geo_2?: string,
  geo_3?: string,
  geo_4?: string,
  geo_5?: string,
  structure_1?: string,
  structure_2?: string,
  structure_3?: string,
  structure_4?: string,
  structure_5?: string,
  structure_6?: string,
  structure_7?: string,
  structure_8?: string,
  structure_9?: string,
  structure_10?: string,
  homologado?: string,
  academico?: string,
  contratacion?: string,
  personal?: string,
  jornada?: string,
  rotacion?: string,
  id_CT?: number
}
export interface nombresColumnasEnBD {
  _id?: string,
  productoId?: string,
  fullName?: string,
  ownKey?: string,
  email?: string,
  phone?: string,
  extension?: string,
  cellphone?: string,
  country?: string,
  location?: string,
  area?: string,
  bossKey?: string,
  native?: string,
  charge?: string,
  answer?: string,
  age?: string,
  gender?: string,
  typeofwork?: string,
  workCondition?: string,
  antiquity?: string,
  geo_1?: string,
  geo_2?: string,
  geo_3?: string,
  geo_4?: string,
  geo_5?: string,
  structure_1?: string,
  structure_2?: string,
  structure_3?: string,
  structure_4?: string,
  structure_5?: string,
  structure_6?: string,
  structure_7?: string,
  structure_8?: string,
  structure_9?: string,
  structure_10?: string,
  homologado?: string,
  academico?: string,
  contratacion?: string,
  personal?: string,
  jornada?: string,
  rotacion?: string,
  id_CT?: string
}
export interface errorEncontrado{
  numeroFila:number,
  datos: any,
  listaErrores: listaErrores[]
}
export interface listaErrores{
  columna: string,
  dato: any,
  tipoError: string
}
////respuesta al guardar bd colabs
export interface respuestaGuardaBD{
  colaboradores: number,
  fechaRegistro: string,
  message: string
}
////respuesta getfast
export interface getBDFast{
  message: string,
  numeroColaboradores: number,
  fecha: string
}

export interface getBD_CTFast{
  message: string,
  numeroCentrosTrabajo: number,
  fecha: string
}
////respuesta getfull

export interface getBDFull{
  message: string,
  bdcolaboradores: Colaborador[],
  columnas: nombresColumnasEnBD
}
////respuesta elimina bd
export interface respuestaEliminaBD{
  fecha: string,
  message: string,
  respuesta: number
}
export const CLAVES_COLUMNAS_CT = [
  'id_CT',
  'nombre_CT',
  'domicilio_CT',
  'actividad_principal_CT',
  'tamanio_CT',
  'nombre_responsable_CT',
  'email_responsable_CT',
  'email_razon_social'
]

export const CLAVES_COLUMNASCT = [
  'productoId',
  'id_CT',
  'nombre_CT',
  'domicilio_CT',
  'actividad_principal_CT',
  'nombre_responsable_CT',
  'email_responsable_CT',
  'email_razon_social'
]


export const TIPO_VALIDACION_CT = [
  'numerica',
  'alfanumerica',
  'alfanumerica',
  'alfabetica',
  'numerica',
  'alfabetica',
  'email',
]
export const COLUMNAS_OBLIGATORIAS_CT = [
  'id_CT',
  'nombre_CT',
  'domicilio_CT',
  'actividad_principal_CT',
  'tamanio_CT',
  'nombre_responsable_CT',
  'email_responsable_CT',
]

export interface getBDFullCT{
  message: string,
  bdcentrosTrabajo: CentroTrabajo[],
  columnas: nombresColumnasEnBDCT
}

export interface CentroTrabajo {
  _id: string,
  id_CT: any,
  productoId: string,
  nombre_CT: string,
  domicilio_CT: string,
  actividad_principal_CT: string,
  tamanio_CT:number,
  nombre_responsable_CT: string,
  email_responsable_CT: string,
  email_razon_social?: string
}

export interface nombresColumnasEnBDCT {
  _id: string,
  id_CT: any,
  productoId: string,
  nombre_CT: string,
  domicilio_CT: string,
  actividad_principal_CT: string,
  tamanio_CT:number,
  nombre_responsable_CT: string,
  email_responsable_CT: string,
  email_razon_social?: string
}
